import { memo } from "react";

interface CardAlertProps {
  message: string;
}

export const CardAlert = memo(({ message }: CardAlertProps) => {
  return (
    <div className="p-4">
      <div className="text-center text-gray-500">{message}</div>
    </div>
  );
});
